import script from "./TransactionPageConfirmation.vue?vue&type=script&setup=true&lang=ts"
export * from "./TransactionPageConfirmation.vue?vue&type=script&setup=true&lang=ts"

import "./TransactionPageConfirmation.vue?vue&type=style&index=0&id=d479f126&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d479f126"]])

export default __exports__